// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AcoesMarketing_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /marketing/acoes/lista — every filter is OPTIONAL:
 * período (data_inicio/data_fim, YYYY-MM-DD, inclusive), franquia_id, tipo.
 * The franchise scope of a Franqueado/Gerente is applied by the controller on
 * top of these; it can only narrow.
 */
import { registerContract } from './validate'

export interface AcoesMarketing_ListaInput {
data_inicio?: string
data_fim?: string
franquia_id?: string
tipo?: string
}

registerContract('AcoesMarketing_ListaInput', {
  data_inicio: { type: 'string',  required: false },
  data_fim:    { type: 'string',  required: false },
  franquia_id: { type: 'string',  required: false },
  tipo:        { type: 'string',  required: false },
})
